import { styled, css, Box } from '@mui/material'
import Text from '../../Text'
import Price from '../../Price'

export const SummaryTotalsContainer = styled(Box)(
  () => css`
    display: flex;
    flex-direction: column;
    gap: 5px;
    padding: 20px 0 0 0;
  `
)

export const SubTotalLabel = styled(Text)(
  ({ theme }) => css`
    color: ${theme.palette.text.primary};
    font-weight: 700;
    font-size: 12px;
    line-height: 130%;
  `
)

export const TotalLabel = styled(Text)(
  ({ theme }) => css`
    color: ${theme.palette.text.primary};
    font-weight: 700;
    font-size: 16px;
    line-height: 130%;
  `
)

export const TotalPrice = styled(Price)(() => css``)
TotalPrice.defaultProps = {
  size: '16px'
}

export const FeePrice = styled(Price)(
  () => css`
    font-weight: 500;
  `
)
FeePrice.defaultProps = {
  size: '10px',
  color: 'text.secondary'
}

export const SubTotalPrice = styled(Price)(
  ({ theme }) => css`
    color: ${theme.palette.text.primary};
    font-weight: 700;
  `
)

export const SummaryListSubtotal = styled(Box)(
  ({ theme }) => css`
    display: flex;
    gap: 10px;
    flex-direction: column;
    justify-content: space-between;
    background-color: ${theme.palette.grey[100]};
    border-radius: 8px;
    padding: 12px 8px;
  `
)

export const SummaryListTotal = styled(Box)(
  () => css`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 17px 8px 0 8px;
    gap: 10px;
  `
)

export const SummaryTotalContainer = styled(Box)(
  () => css`
    display: flex;
    gap: 10px;
    flex-direction: row;
    justify-content: space-between;
    font-weight: 500;
    font-size: 16px;
  `
)
export const FeeLabel = styled(Text)(
  ({ theme }) => css`
    color: ${theme.palette.text.secondary};
    font-weight: 500;
    font-size: 10px;
  `
)
